import * as React from "react";

import { IconUpload } from "../icons/IconUpload";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonUpload: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonUpload.title;

    return (
        <MprcIconButton {...rest} title={lTitle}>
            <IconUpload fixedWidth />
        </MprcIconButton>
    );
};
